import React from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import ComponentContainer from '../common/ComponentContainer';
import { StyledWebView } from '../common/StyledWebView';

const STYLED_WEB_VIEW_ID = 'wysiwyg';

const WYSIWYG = ({ customStyle, html, nodeTypeAlias = 'WYSIWYG', text, width }) => {
    return (
        <View dataSet={{ umbracoComponentName: nodeTypeAlias }}>
            <ComponentContainer>
                <StyledWebView customStyle={customStyle} html={text || html} nodeId={STYLED_WEB_VIEW_ID} width={width} />
            </ComponentContainer>
        </View>
    );
};

WYSIWYG.propTypes = {
    html: PropTypes.string,
    customStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default WYSIWYG;
